import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RelativeTimePipe } from './relative-time.pipe';
import { ExcerptPipe } from "./excerpt.pipe";
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { AppDisplayCurrencyPipe, AppDisplayDatePipe, AppDisplayDateTimePipe, AppDisplayNumberPipe, AppDisplayTimePipe } from './app-config.pipe';

const pipes = [
  RelativeTimePipe,
  ExcerptPipe,
  GetValueByKeyPipe,
  AppDisplayDatePipe,
  AppDisplayTimePipe,
  AppDisplayDateTimePipe,
  AppDisplayNumberPipe,
  AppDisplayCurrencyPipe
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule { }